var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetFreeCreditsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:chats"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7344 5.2168H13.9219V2.4043C13.9219 2.03134 13.7737 1.67365 13.51 1.40993C13.2463 1.1462 12.8886 0.998047 12.5156 0.998047H1.26562C0.892664 0.998047 0.534979 1.1462 0.271256 1.40993C0.007533 1.67365 -0.140625 2.03134 -0.140625 2.4043V13.6543C-0.140212 13.7866 -0.102492 13.9161 -0.0317971 14.0279C0.0388976 14.1397 0.139699 14.2293 0.259026 14.2864C0.378353 14.3435 0.511366 14.3657 0.642783 14.3506C0.7742 14.3355 0.898691 14.2837 1.00195 14.201L4.07812 11.7207V14.3574C4.07812 14.7304 4.22628 15.0881 4.49001 15.3518C4.75373 15.6155 5.11141 15.7637 5.48438 15.7637H13.7101L16.998 18.4197C17.1225 18.5204 17.2775 18.5755 17.4375 18.5762C17.624 18.5762 17.8028 18.5021 17.9347 18.3702C18.0665 18.2384 18.1406 18.0595 18.1406 17.873V6.62305C18.1406 6.25009 17.9925 5.8924 17.7287 5.62868C17.465 5.36496 17.1073 5.2168 16.7344 5.2168ZM3.59912 10.2951L1.26562 12.1821V2.4043H12.5156V10.1387H4.04121C3.88029 10.1387 3.72424 10.1939 3.59912 10.2951ZM16.7344 16.4009L14.4009 14.5139C14.2765 14.4132 14.1214 14.358 13.9614 14.3574H5.48438V11.5449H12.5156C12.8886 11.5449 13.2463 11.3968 13.51 11.133C13.7737 10.8693 13.9219 10.5116 13.9219 10.1387V6.62305H16.7344V16.4009Z",
    fill: "#F1B315"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.89062 3.81055L6.89062 8.0293M9 5.91992L4.78125 5.91992",
    stroke: "#F1B315",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetFreeCreditsIcon);
export default __webpack_public_path__ + "static/media/get_free_credits_icon.b2f00309896df5cc48a839f5999d5094.svg";
export { ForwardRef as ReactComponent };